/** One account lifetime. Rotating it cancels I/O and invalidates callbacks,
 * including responses that completed just before fetch observed the abort. */
export interface SessionLifetime {
  readonly signal: AbortSignal;
}

let controller = new AbortController();
let lifetime: SessionLifetime = Object.freeze({ signal: controller.signal });

export function currentLifetime(): SessionLifetime {
  return lifetime;
}

export function isCurrent(scope: SessionLifetime): boolean {
  return scope === lifetime && !scope.signal.aborted;
}

export function assertCurrent(scope: SessionLifetime): void {
  if (!isCurrent(scope)) throw new DOMException("session ended", "AbortError");
}

export function endLifetime(): void {
  const previous = controller;
  controller = new AbortController();
  lifetime = Object.freeze({ signal: controller.signal });
  previous.abort(new DOMException("session ended", "AbortError"));
}

/** Slow-mode waits must release the sender immediately when an account ends. */
export function sessionDelay(ms: number, scope: SessionLifetime): Promise<void> {
  assertCurrent(scope);
  return new Promise((resolve, reject) => {
    const onAbort = () => {
      clearTimeout(timer);
      reject(scope.signal.reason);
    };
    const timer = setTimeout(() => {
      scope.signal.removeEventListener("abort", onAbort);
      resolve();
    }, ms);
    scope.signal.addEventListener("abort", onAbort, { once: true });
  });
}
